// import { Navigate, Outlet } from "react-router-dom";

// const ProtectedRoutes = () => {
//   const token = window.localStorage.getItem("ProviderToken");

//   if (token) return <Outlet />;
//   return <Navigate to={"/auth/login"} />;
// };

// export default ProtectedRoutes;

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useJsApiLoader } from "@react-google-maps/api";
import {
  GOOGLE_MAPS_LIBRARIES,
  GOOGLE_MAPS_API_KEY,
} from "../utils/googleMapsConfig";

const ProtectedRoutes = () => {
  const token = window.localStorage.getItem("ProviderToken");
  const setup = window.localStorage.getItem("ProviderSetup");
  const setupCompleted = setup === "true";
  const location = useLocation();
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  if (!token) return <Navigate to="/auth/login" />;
  if (!setupCompleted && !location.pathname.startsWith("/business-setup")) {
    return <Navigate to="/business-setup" />;
  }
  
  if (loadError) {
    const isApiBlockedError = 
      loadError.message?.includes("ApiTargetBlockedMapError") ||
      loadError.message?.includes("ApiTargetBlocked") ||
      loadError.name === "ApiTargetBlockedMapError";
    
    return (
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="text-center py-5">
            <div className="alert alert-danger" role="alert">
              <h4 className="alert-heading">Google Maps API Error</h4>
              {isApiBlockedError ? (
                <>
                  <p className="mb-3">
                    <strong>API Key Restriction Error:</strong> The Google Maps API key is blocked for this domain.
                  </p>
                  <hr />
                  <p className="mb-2"><strong>To fix this issue:</strong></p>
                  <ol className="text-start" style={{ maxWidth: "600px", margin: "0 auto" }}>
                    <li>Go to <a href="https://console.cloud.google.com/google/maps-apis/credentials" target="_blank" rel="noopener noreferrer">Google Cloud Console - API Credentials</a></li>
                    <li>Click on your API key</li>
                    <li>Under "Application restrictions", select "HTTP referrers (web sites)"</li>
                    <li>Add your domain referrers (e.g., <code>http://localhost:3000/*</code> for development)</li>
                    <li>Make sure "Maps JavaScript API" and "Places API" are enabled</li>
                    <li>Click "Save" and refresh this page</li>
                  </ol>
                </>
              ) : (
                <p>Error loading Google Maps: {loadError.message || "Unknown error"}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  if (!isLoaded) return null;

  return <Outlet />;
};

export default ProtectedRoutes;
